var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonZonkarta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.189,
    height: 58.587,
    viewBox: "0 0 69.189 58.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digitala_Zonkartor",
    "data-name": "Digitala Zonkartor",
    transform: "translate(14813.957 19535.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24303",
    "data-name": "Group 24303",
    transform: "translate(-14813.957 -19533.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24302",
    "data-name": "Group 24302",
    transform: "translate(0 36.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_3576",
    "data-name": "Line 3576",
    transform: "translate(3.15 1.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37571",
    "data-name": "Path 37571",
    d: "M2.613.4,27.735,16.028",
    transform: "translate(-1.742 -0.054)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37572",
    "data-name": "Path 37572",
    d: "M27.859,16.452c-.072,0-.144,0-.214-.011a1.831,1.831,0,0,1-.2-.031,1.318,1.318,0,0,1-.178-.051.8.8,0,0,1-.146-.07L2.013.647A.277.277,0,0,1,1.894.521.145.145,0,0,1,1.909.39.372.372,0,0,1,2.047.268,1.049,1.049,0,0,1,2.3.17c.039-.01.078-.019.119-.026S2.5.131,2.542.126s.084-.009.126-.011.085,0,.127,0c.07,0,.138,0,.205.01a1.779,1.779,0,0,1,.192.029A1.249,1.249,0,0,1,3.36.2.735.735,0,0,1,3.5.261L28.635,15.874a.322.322,0,0,1,.132.135.159.159,0,0,1-.006.142.357.357,0,0,1-.135.132,1,1,0,0,1-.256.105c-.039.011-.08.02-.122.028s-.084.015-.127.02-.087.009-.13.012S27.9,16.452,27.859,16.452Z",
    transform: "translate(-1.885 -0.111)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3577",
    "data-name": "Line 3577",
    transform: "translate(28.24 1.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37573",
    "data-name": "Path 37573",
    d: "M35.5.406,1.091,16.033",
    transform: "translate(-0.187 -0.062)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37574",
    "data-name": "Path 37574",
    d: "M1.219,16.46c-.053,0-.106,0-.158-.006s-.1-.01-.154-.017-.1-.017-.146-.029a1.27,1.27,0,0,1-.134-.041.659.659,0,0,1-.211-.117.217.217,0,0,1-.08-.137.185.185,0,0,1,.052-.141.539.539,0,0,1,.186-.127L34.987.235a1.039,1.039,0,0,1,.139-.051,1.5,1.5,0,0,1,.159-.036c.056-.01.113-.017.172-.022s.119-.007.179-.007.1,0,.153.005.1.009.149.016.1.016.143.027A1.348,1.348,0,0,1,36.213.2a.713.713,0,0,1,.212.108.224.224,0,0,1,.088.127.156.156,0,0,1-.039.131.462.462,0,0,1-.169.118L1.9,16.334a1.137,1.137,0,0,1-.149.055,1.593,1.593,0,0,1-.168.039c-.059.011-.119.018-.181.024S1.281,16.46,1.219,16.46Z",
    transform: "translate(-0.335 -0.119)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3578",
    "data-name": "Line 3578",
    transform: "translate(42.592 1.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37575",
    "data-name": "Path 37575",
    d: "M20.815.288H.733",
    transform: "translate(0.137 0.055)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37576",
    "data-name": "Path 37576",
    d: "M20.968.688H.869A2.06,2.06,0,0,1,.53.661,1.36,1.36,0,0,1,.255.587.579.579,0,0,1,.071.478.181.181,0,0,1,.006.344.19.19,0,0,1,.077.211.612.612,0,0,1,.266.1,1.4,1.4,0,0,1,.544.028,2.081,2.081,0,0,1,.883,0H20.948a2.085,2.085,0,0,1,.339.027A1.412,1.412,0,0,1,21.566.1a.619.619,0,0,1,.19.109.192.192,0,0,1,.072.134.179.179,0,0,1-.064.134.572.572,0,0,1-.183.109,1.351,1.351,0,0,1-.275.074A2.056,2.056,0,0,1,20.968.688Z",
    transform: "translate(-0.006 -0.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24301",
    "data-name": "Group 24301",
    transform: "translate(0.2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_724",
    "data-name": "Ellipse 724",
    d: "M5.89,0A12.579,12.579,0,0,1,7.974.166,7.956,7.956,0,0,1,9.641.622a3.243,3.243,0,0,1,1.092.677,1.04,1.04,0,0,1,.343.837,1.306,1.306,0,0,1-.509.837,4.235,4.235,0,0,1-1.235.685,9.317,9.317,0,0,1-1.78.463,13.254,13.254,0,0,1-2.142.17A12.555,12.555,0,0,1,3.3,4.113,7.875,7.875,0,0,1,1.63,3.651,3.163,3.163,0,0,1,.553,2.965a1.02,1.02,0,0,1-.323-.837,1.343,1.343,0,0,1,.53-.837A4.332,4.332,0,0,1,2,.622,9.4,9.4,0,0,1,3.77.166,13.273,13.273,0,0,1,5.89,0Z",
    transform: "translate(-0.227 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_725",
    "data-name": "Ellipse 725",
    d: "M5.392,0A13.011,13.011,0,0,1,7.5.166,8.848,8.848,0,0,1,9.233.622a3.9,3.9,0,0,1,1.186.677,1.211,1.211,0,0,1,.46.837,1.108,1.108,0,0,1-.392.837,3.532,3.532,0,0,1-1.14.685,8.39,8.39,0,0,1-1.716.463,12.815,12.815,0,0,1-2.118.17,12.994,12.994,0,0,1-2.126-.177,8.762,8.762,0,0,1-1.742-.463A3.808,3.808,0,0,1,.472,2.965a1.181,1.181,0,0,1-.44-.837,1.134,1.134,0,0,1,.413-.837A3.617,3.617,0,0,1,1.586.622,8.471,8.471,0,0,1,3.3.166,12.832,12.832,0,0,1,5.392,0Z",
    transform: "translate(58.109 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_726",
    "data-name": "Ellipse 726",
    d: "M5.475,0A11.016,11.016,0,0,1,7.489.179,7.33,7.33,0,0,1,9.121.67a3.31,3.31,0,0,1,1.086.728,1.246,1.246,0,0,1,.374.9,1.366,1.366,0,0,1-.448.9,3.738,3.738,0,0,1-1.155.738,7.919,7.919,0,0,1-1.692.494,11.316,11.316,0,0,1-2.049.188A11,11,0,0,1,3.2,4.429a7.259,7.259,0,0,1-1.639-.5A3.236,3.236,0,0,1,.488,3.193a1.223,1.223,0,0,1-.359-.9A1.4,1.4,0,0,1,.6,1.4,3.819,3.819,0,0,1,1.755.67,7.989,7.989,0,0,1,3.442.179,11.329,11.329,0,0,1,5.475,0Z",
    transform: "translate(23.671 15.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3579",
    "data-name": "Line 3579",
    transform: "translate(0 1.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37577",
    "data-name": "Path 37577",
    d: "M21.025.288H.763",
    transform: "translate(0.109 0.055)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37578",
    "data-name": "Path 37578",
    d: "M21.141.688H.863A2.01,2.01,0,0,1,.527.661,1.257,1.257,0,0,1,.26.587.5.5,0,0,1,.087.478.163.163,0,0,1,.035.344.216.216,0,0,1,.12.211.7.7,0,0,1,.32.1,1.514,1.514,0,0,1,.606.028,2.133,2.133,0,0,1,.948,0H21.192a2.034,2.034,0,0,1,.336.027A1.307,1.307,0,0,1,21.8.1a.541.541,0,0,1,.178.109.172.172,0,0,1,.059.134.2.2,0,0,1-.078.134.654.654,0,0,1-.194.109,1.459,1.459,0,0,1-.282.074A2.107,2.107,0,0,1,21.141.688Z",
    transform: "translate(-0.034 -0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24300",
    "data-name": "Group 24300",
    transform: "translate(14.761 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24145",
    "data-name": "Path 24145",
    d: "M76.751,203.305c0,9.446-10.927,27.98-17.106,27.98-5.652,0-17.106-18.534-17.106-27.98a17.107,17.107,0,1,1,34.213,0Z",
    transform: "translate(-42.539 -186.198)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_581",
    "data-name": "Ellipse 581",
    cx: 5.84,
    cy: 5.84,
    r: 5.84,
    transform: "translate(11.265 11.379)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonZonkarta);
export default __webpack_public_path__ + "static/media/Ikon_Zonkarta.7f8939aa85c22e6090040cad2defe732.svg";
export { ForwardRef as ReactComponent };